import React, { useState } from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import {ThemedText, ThemedView} from '@app/theme';
import InProgress from "@app/assets/svg/InProgress";
import SystemWarning from "../../../../assets/Icons/SystemWarning";
import Button from "@sharedComponents/Button/Button";
import { trackEvent } from '@app/utils';

interface EditLimitCardProps {
    yesAction: () => void;
    noAction: () => void;
    colors: any;
    loader: boolean;
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
}

const EditLimit: React.FC<EditLimitCardProps> = ({ yesAction, noAction, colors, loader, isVisible, setIsVisible}) => {

    
    return (
    <BottomSheetContainer
        isVisible={isVisible}
        close={() => {
            setIsVisible(false);
            noAction();
        }}
        onClose={() => {
            setIsVisible(false);
            noAction();
        }}
        dragComponent={undefined}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        showCloseIcon={true}
        containerStyle={{backgroundColor: '#fefefe'}}
    >
        <ThemedView alignItems={"center"} padding={"lg"}>
          <ThemedView mt={"sm"}>
            <SystemWarning/>

          </ThemedView>
            <ThemedText mt={"2xl"} variant={"h5s"} mb={"2xl"} textAlign={"center"} color={'text-primary'}>
                Are you sure you want to edit your limit? This will reset your selected limit.
            </ThemedText>

            <Button
                label="Yes, continue to edit limit"
                type="SOLID"
                size='MD'
                disabled={false}
                handlePress={() => {
                    setIsVisible(false);
                    yesAction();
                    trackEvent('KYC_STEPPER_EDIT_LIMIT_CONFIRMED')
                }}
                buttonLoader={loader}
                bg={colors['bg-action-primary']}
                textColor={colors['text-primary']}
            />

            <ThemedView mt={"md"} width={"100%"}>
                <Button
                    label="No, continue with selected limit"
                    type="OUTLINED"
                    size='MD'
                    disabled={false}
                    handlePress={() => {
                        setIsVisible(false);
                        noAction();
                        trackEvent('KYC_STEPPER_EDIT_LIMIT_CANCELLED')
                    }}
                    bg={colors['bg-action-primary']}
                    textColor={colors['text-primary']}
                />
            </ThemedView>


        </ThemedView>
    </BottomSheetContainer> 
    );
};

export default EditLimit;